<template>
  <a-layout-header class="labos-header">
    <div class="header-content">
      <a class="brand" href="/" aria-label="LabOS home">
        <img :src="logoSrc" alt="LabOS logo" class="logo-img" />
        <span class="brand-text">LabOS</span>
      </a>

      <nav class="nav-menu" aria-label="Account">
        <a class="auth-btn login-btn" :href="loginUrl">Login</a>
        <a class="auth-btn signup-btn" :href="loginUrl">Sign up</a>
      </nav>
    </div>
  </a-layout-header>
</template>

<script setup lang="ts">
import logoSrc from '@/assets/picture/LabOS_logo.png'

const loginUrl = 'https://app.ai4labos.com/login'
</script>

<style scoped>
.labos-header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(229, 231, 235, 0.5);
  padding: 0;
  height: 58px;
  line-height: 58px;
}

.header-content {
  max-width: 1160px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  min-width: 0;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  letter-spacing: 0.2px;
  color: #1f2937;
  min-width: 0;
  text-decoration: none;
}

.brand:hover {
  color: #1f2937;
}

.logo-img {
  height: 28px;
  width: auto;
}

.brand-text {
  font-size: 16px;
  line-height: 1;
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  min-width: 0;
}

.auth-btn {
  height: 32px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.login-btn {
  color: #4f46e5;
  background: #ffffff;
  border: 1px solid rgba(79, 70, 229, 0.24);
}

.login-btn:hover {
  color: #4338ca;
  border-color: rgba(79, 70, 229, 0.45);
  transform: translateY(-1px);
}

.signup-btn {
  color: #ffffff;
  background: linear-gradient(90deg, #8b5cf6 0%, #22d3ee 100%);
  border: 1px solid transparent;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.18);
}

.signup-btn:hover {
  color: #ffffff;
  transform: translateY(-1px);
}

@media (max-width: 640px) {
  .header-content {
    padding: 0 14px;
  }

  .nav-menu {
    gap: 8px;
  }

  .auth-btn {
    height: 30px;
    padding: 0 10px;
    font-size: 12px;
  }
}
</style>
